import { createColorPalette, hexToRgba } from '../utility/colors';

export const SECTIONS_COLORS = {
  DEFAULT: {
    base: '#E97CC2',
    secondary: '#AA98CB',
  },
  OVERVIEW: {
    base: '#D86932',
    secondary: '#79985D',
  },
  LANDING: {
    base: '#D9A54A',
    secondary: '#81B5D5',
  },
  TICKETS: {
    base: '#81B5D5',
    secondary: '#D9A54A',
  },
  SESSIONS: {
    base: '#E97CC2',
    secondary: '#AA98CB',
  },
  PEOPLE: {
    base: '#7B9B5F',
    secondary: '#E97CC2',
  },
  LOBBY: {
    base: '#D87432',
    secondary: '#79985D',
  },
  BOOTHS: {
    base: '#D87432',
    secondary: '#79985D',
  },
  MEETINGS: {
    base: '#D9A54A',
    secondary: '#81B5D5',
  },
  LOUNGE: {
    base: '#7B84C4',
    secondary: '#E67BC0',
  },
  ROOMS: {
    base: '#E97CC2',
    secondary: '#AA98CB',
  },
  EMAILS: {
    base: '#7B84C4',
    secondary: '#E67BC0',
  },
  ENGAGEMENT: {
    base: '#81B5D5',
    secondary: '#D9A54A',
  },
  ANALYTICS: {
    base: '#D86932',
    secondary: '#79985D',
  },
  SETTINGS: {
    base: '#D9A54A',
    secondary: '#81B5D5',
  },
  INTEGRATIONS: {
    base: '#7B84C4',
    secondary: '#E67BC0',
  },
  ACCOUNT: {
    base: '#E97CC2',
    secondary: '#AA98CB',
  },
  PAYOUT: {
    base: '#81B5D5',
    secondary: '#D9A54A',
  },
  TEAM: {
    base: '#D87432',
    secondary: '#79985D',
  },
  AUTH: {
    base: '#CE473C',
    secondary: '#81B5D5',
  },
  DATA_MAPPING: {
    base: '#81B5D5',
    secondary: '#D9A54A',
  },
  WP_AUTH: {
    base: '#FF4E3C',
    secondary: '#161519',
  },
  WP_DEFAULT: {
    base: '#FF4E3C',
    secondary: '#161519',
  }
};

export const SECTIONS = {
  DEFAULT: 'DEFAULT',
  OVERVIEW: 'OVERVIEW',
  LANDING: 'LANDING',
  TICKETS: 'TICKETS',
  SESSIONS: 'SESSIONS',
  PEOPLE: 'PEOPLE',
  LOBBY: 'LOBBY',
  BOOTHS: 'BOOTHS',
  MEETINGS: 'MEETINGS',
  LOUNGE: 'LOUNGE',
  ROOMS: 'ROOMS',
  EMAILS: 'EMAILS',
  ENGAGEMENT: 'ENGAGEMENT',
  ANALYTICS: 'ANALYTICS',
  SETTINGS: 'SETTINGS',
  INTEGRATIONS: 'INTEGRATIONS',
  ACCOUNT: 'ACCOUNT',
  PAYOUT: 'PAYOUT',
  TEAM: 'TEAM',
  EVENTS: 'EVENTS',
  AUTH: 'AUTH',
  DATA_MAPPING: 'DATA_MAPPING',
  WP_AUTH: 'WP_AUTH',
  WP_DEFAULT: 'WP_DEFAULT',
};

export const getSectionTheme = (sectionKey) => {
  const section = SECTIONS_COLORS[sectionKey] || SECTIONS_COLORS.DEFAULT;
  const primaryColor = createColorPalette(section.base);
  const secondaryColor = createColorPalette(section.secondary);
  return {
    sectionColor: section.base,
    menuColor: hexToRgba(section.base, 0.2),
    logoPrimary: section.base,
    logoSecondary: section.secondary,
    sidebarActive: hexToRgba(section.base, 0.35),
    sidebarHover: hexToRgba(section.base, 0.35),
    primaryColor: { ...primaryColor, extraLight: hexToRgba(section.base, 0.1) },
    secondaryColor: { ...secondaryColor, extraLight: hexToRgba(section.secondary, 0.1) },
  };
};
